import { render, staticRenderFns } from "./CaptionText.vue?vue&type=template&id=245b6384&scoped=true"
import script from "./CaptionText.vue?vue&type=script&lang=js"
export * from "./CaptionText.vue?vue&type=script&lang=js"
import style0 from "./CaptionText.vue?vue&type=style&index=0&id=245b6384&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245b6384",
  null
  
)

export default component.exports